import {
  entitlementBlockerDefaultUserMessage,
  isEntitlementBlockerCode,
} from "@/features/billing/entitlement-reason-codes"
import {
  isUploadPublicCode,
  publicApiMessageForUploadCode,
  UPLOAD_PUBLIC_CODES,
  type UploadPublicCode,
} from "@/lib/api/upload-public"

/**
 * User-facing copy for upload flows. Never pass through raw `error.message` from the API.
 */
export function userFacingUploadMessageForCode(
  code: UploadPublicCode | undefined,
): string {
  if (!code) {
    return publicApiMessageForUploadCode(
      UPLOAD_PUBLIC_CODES.UPLOAD_FAILED_GENERIC,
    )
  }
  return publicApiMessageForUploadCode(code)
}

export function mapUploadApiErrorToUserMessage(error: {
  code?: string
  message?: string
} | null): string {
  const c = error?.code
  if (c && isEntitlementBlockerCode(c)) {
    return error?.message?.trim() || entitlementBlockerDefaultUserMessage(c)
  }
  if (c && isUploadPublicCode(c)) {
    return userFacingUploadMessageForCode(c)
  }
  return userFacingUploadMessageForCode(undefined)
}
